<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emSppStorageSstResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" withCustomRowActions import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">

                              <!--
                              <template #left-header>
                                <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-arrow-down"
                                           custom-label="勾选入库"
                                           v-bind:class="'btn btn-outline-primary btn-sm'"
                                           @click="entryStorage">
                                </em-button>
                              </template>
                              -->
                              <template #customRowActions="{row}">
                                <b-button-group>
                                  <em-button type="gotoChild"
                                             v-bind:class="'btn btn-outline-primary btn-sm'"
                                             @click="gotoChild(row)" custom-label="转到库房储位">
                                  </em-button>
                                </b-button-group>
                              </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author thq
    // Date 2021-04-16 01:02:24

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonGotoMixin from "@/mixin/em/common/goto";

    export default {
        name: "emSppStorageSstListView",
        mixins: [emCommonListMixin,emCommonGotoMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        },
        methods:{
          gotoChild(row) {
            this.$_emGotoMixin_gotoHolderList(
                "emSppStorageLoc",
                {sslIdSstFilter: row.id},
                {sslIdSst: row.id},
                false,
                {mainId:row.id}
            )
          }
        }

    };
</script>
